module.exports = __webpack_public_path__ + "img/banner.0a9761fa.png";